import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const needVerifyUserInMixpanel = (bool: boolean) => dispatch => {
  dispatch(action(USER_ACTION_TYPES.need_verify_user_in_mixpanel, { bool }))
}



// WEBPACK FOOTER //
// ./src/store/user/actions/needVerifyUserInMixpanel.action.ts